import { PublicVideo } from '@wix/wix-vod-api-site-based/dist/src/public/services/video/video';
import { toError } from 'api/parsers/transport-error';
import { hosts } from '@wix/wix-vod-shared/dist/src/common/settings/settings';
import { publicCatalogServiceConfig } from 'api/config/catalog-service';

const service = new PublicVideo(publicCatalogServiceConfig);

export const getDownloadUrl = (videoId, channelId, instance) =>
  PublicVideo.getDownloadUrl(hosts.catalog, videoId, channelId, instance);

export const getVideoUrls = (videoId, channelId, instance) =>
  service
    .getVideoUrls(videoId, channelId, instance)
    .then(response => response.data)
    .catch(toError);
